import React from 'react';
import Drawer from '@material-ui/core/Drawer';
import { useHistory } from 'react-router-dom';
import { useSelector } from 'react-redux';

import MemberMenu from '../components/nav/MemberMenu';
import InvoicePaymentStatusPage from './InvoicePaymentStatusPage';
import config from '../config';

const InvoicePaymentStatusLayout = () => {
  const history = useHistory();
  const tenant = useSelector(state => state.tenant);

  const handleReturn = () => {
    history.push(config.auth.rootUrl);
  };

  return (
    <div className="account-page">
      <Drawer variant="permanent" anchor="left">
        <MemberMenu onClose={handleReturn} tenant={tenant} />
      </Drawer>

      <div className="body-container">
        <InvoicePaymentStatusPage />
      </div>
    </div>
  );
};

export default InvoicePaymentStatusLayout;
